export default {"src":"/_next/static/media/mouse-keyboard.fdaa5255.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};